<ng-template #impersonationBanner>
  @if (showImpersonationBanner) {
    <div class="impersonation-top-bar flex align-items-center justify-content-between px-3">
      <div class="flex-1">
        <span
          class="badge inline-flex align-items-center gap-2 font-semibold cursor-pointer"
          [pTooltip]="isImpersonating ? 'You are impersonating an account as super admin.' : 'Logged in as super admin.'"
          tooltipPosition="right"
        >
          {{ isImpersonating ? 'Impersonate mode' : 'Super User mode' }}
          <i class="pi pi-info-circle"></i>
        </span>
      </div>
      <div class="flex-auto text-center font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis" style="font-size: 13px;">
        <span>{{ isImpersonating ? 'You are impersonating ' + impersonationText.replace('Impersonating: ', '') : impersonationText }}</span>
      </div>
      <div class="flex-1"></div>
    </div>
  }
</ng-template>

<ng-template #paymentBanner>
  @if (showPaymentBanner) {
    <div class="impersonation-top-bar payment-top-bar flex align-items-center justify-content-between px-3" [class.stacked]="showImpersonationBanner">
      <div class="flex-1">
        <span
          class="badge inline-flex align-items-center gap-2 font-semibold cursor-pointer"
          pTooltip="Payments cannot be accepted until a Stripe account is connected."
          tooltipPosition="right"
        >
          Payment setup
          <i class="pi pi-info-circle"></i>
        </span>
      </div>
      <div class="flex-auto text-center font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis" style="font-size: 13px;">
        <span>{{ paymentBannerMessage ?? 'Please connect your Stripe payment account to start accepting payments.' }}</span>
      </div>
      <div class="flex-1 flex justify-content-end">
        <button type="button" class="payment-banner-continue" (click)="goToStripeSetup()">Continue</button>
      </div>
    </div>
  }
</ng-template>

@if (!ui.isNew()) {
  <app-navbar
    [sideNavComponent]="sidenav"
    [showNav]="showNavigation$"
  ></app-navbar>

  <ng-container *ngTemplateOutlet="impersonationBanner"></ng-container>
  <ng-container *ngTemplateOutlet="paymentBanner"></ng-container>

  <app-side-nav #sidenav>
    <app-side-nav-container></app-side-nav-container>
    <div
      class="main-content"
      [ngClass]="{
        'content-expanded': !isSideNavCollapsed,
        'content-collapsed': isSideNavCollapsed,
        'help-panel-open': isHelpPanelOpen
      }"
      [style.padding-right]="isHelpPanelOpen ? helpPanelWidth + 'px' : null"
    >
      <router-outlet></router-outlet>
    </div>
  </app-side-nav>
} @else {
  <app-new-shell [hasBanner]="hasBanner">
    <ng-container *ngTemplateOutlet="impersonationBanner"></ng-container>
    <ng-container *ngTemplateOutlet="paymentBanner"></ng-container>
    <router-outlet></router-outlet>
  </app-new-shell>
}

<app-help-panel />
<app-feature-announcement-modal />